// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.
import * as Sentry from "@sentry/solid";
import { render } from "solid-js/web";
import { RouterProvider } from "@tanstack/solid-router";
import { QueryClient, QueryClientProvider } from "@tanstack/solid-query";
import "./index.css";
import { router } from "./ui";
import { SessionBoundary } from "./auth/session";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
    },
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });
}

declare module "@tanstack/solid-router" {
  interface Register {
    router: typeof router;
  }
}
const query = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 5_000 } },
});
render(
  () => (
    <QueryClientProvider client={query}>
      <SessionBoundary>
        <RouterProvider router={router} />
      </SessionBoundary>
    </QueryClientProvider>
  ),
  document.getElementById("root")!,
);
